// extracted by mini-css-extract-plugin
export default {"offline":"Offline_offline__ndYsv","text":"Offline_text__5buHA"};